import { isDevEnvironment } from './env';

/* In here we store the Google Optimize global variables which are the parameters
   for the A/B testing
*/

// the window variable is to be defined.

export const TESTS_DICTIONARY = {
  optimizelyAppleGoolePayOrder: 'optimizelyAppleGoolePayOrder', // Added by story 54809(PR#14022), to be cleaned up by story 82212
  optimizelyDisplayResortFeeWithTotalInSuiteCardH: 'optimizelyDisplayResortFeeWithTotalInSuiteCardH', // Added by story 57139(PR#14183), to be cleaned up by story 82763
  optimizelyDisplayResortFeeWithTotalInSuiteCardJ: 'optimizelyDisplayResortFeeWithTotalInSuiteCardJ', // Added by story 57624(PR#14328), to be cleaned up by story 82763
  optimizelyExpressCheckout: 'optimizelyExpressCheckout', // Added by story 61987 & 62104(PR#16014), to be cleaned up by story 82212
  optimizelyI4Iframe: 'optimizelyI4Iframe', // Added by story 62253(PR#16070), to be cleaned up by story ?????
  optimizelyDiningPageRedesign: 'optimizelyDiningPageRedesign', // Added by story 69517(PR#18699), to be cleaned up by story 75581
  optimizelyFamilyRates: 'optimizelyFamilyRates', // Added by story 74739(PR#19243), but change to the family rates story 75387 to be cleaned up by story 82354
  optimizelyFamilyRatesStepper: 'optimizelyFamilyRatesStepper', // Added by story 75387(PR#20412), to be cleaned up by story 77759,
  optimizelyHighlightWolfPass: 'optimizelyHighlightWolfPass', // Added by story 78998(PR#20703), to be cleaned up by story 79524,
  optimizelyHighlightWolfPassVersionC: 'optimizelyHighlightWolfPassVersionC' // Added by story 80363(PR#21561), to be cleaned up by story 79524,
};

/**
 * This is for tests that are located on multiple pages or components.
 * This array is to be empty by default.
 */
const MULTIPLE_TESTS_ACTIVE_LISTS = [];

/**
 *
 * @param {*} testName This is the name of the global variable that is set in Optimizely
 * @param {*} developMode This is a boolean that is set to true if you want to see the test in develop mode
 * @returns
 */
export const getTestValueAB = (testName, developMode = false) => {
  if (developMode) {
    return true;
  }
  if (isDevEnvironment && MULTIPLE_TESTS_ACTIVE_LISTS.includes(testName)) {
    return true;
  }

  return window[testName] || false;
};
